<svg viewBox="0 0 23 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#FFF7DE"/>
<circle cx="11.7273" cy="3" r="3" fill="#FFF7DE"/>
<circle cx="19.9092" cy="3" r="3" fill="#FFF7DE"/>
</svg>
